<template>
  <v-app id="app" class="fill-height">
    <v-main>
      <template v-if="isFetched">
        <router-view />
      </template>
      <main-loader v-else />
    </v-main>
  </v-app>
</template>

<script>
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/shared/MainLoader';
export default {
  name: 'App',
  components: { MainLoader },
  computed: {
    appName: get('admin/appConfig@name'),
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getAppConfig: call('admin/getAppConfig'),
    async init() {
      this.isFetched = false;
      try {
        await this.getAppConfig({ withLayers: true });
        document.title = this.appName;
        this.isFetched = true;
      } catch (e) {
        e;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  overflow-y: hidden;
}
.row + .row {
  margin-top: 0 !important;
}
#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .menu-max-width-content div {
    width: 100%;
  }
  * {
    scrollbar-color: #8f8f8f white;
    scrollbar-width: thin;
  }
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #8f8f8f;
  border: 0px none #ffffff;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #787878;
}
::-webkit-scrollbar-thumb:active {
  background: #6e6e6e;
}
::-webkit-scrollbar-track {
  background: #ededed;
  border: 0px none #ffffff;
  border-radius: 3px;
}
::-webkit-scrollbar-track:hover {
  background: #ededed;
}
::-webkit-scrollbar-track:active {
  background: #ededed;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
